import { ImageCropModal } from '@/components/ui/ImageCropModal';

type AvatarCropModalProps = {
  open: boolean;
  imageSrc: string | null;
  onClose: () => void;
  onConfirm: (file: File) => Promise<void>;
  loading?: boolean;
};

export function AvatarCropModal({
  open,
  imageSrc,
  onClose,
  onConfirm,
  loading = false,
}: AvatarCropModalProps) {
  return (
    <ImageCropModal
      open={open}
      imageSrc={imageSrc}
      title="Ajustar foto"
      description="Arraste e use o zoom para enquadrar seu rosto no círculo."
      confirmLabel="Salvar foto"
      circularCrop
      outputFileName="avatar.jpg"
      onClose={onClose}
      onConfirm={onConfirm}
      loading={loading}
    />
  );
}
